import { defineMessages } from 'react-intl';

export default defineMessages({
  sectionTitle: {
    id: 'fastCover.stepSnowSports.sectionTitle',
    defaultMessage: 'Section 7 - Snow Sports Optional Cover',
  },
  yes: {
    id: 'fastCover.stepSnowSports.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.stepSnowSports.no',
    defaultMessage: 'No',
  },
  areYouClaimingForSnowSportsOptionalCover: {
    id: 'fastCover.stepSnowSports.areYouClaimingForSnowSportsOptionalCover',
    defaultMessage: 'Are you claiming for Snow Sports Optional Cover?',
  },
  areYouClaimingForSnowSportEquipment: {
    id: 'fastCover.stepSnowSports.areYouClaimingForSnowSportEquipment',
    defaultMessage: 'Are you claiming for Snow Sport Equipment?',
  },
  areYouClaimingForSnowEquipmentReplacementHire: {
    id: 'fastCover.stepSnowSports.areYouClaimingForSnowEquipmentReplacementHire',
    defaultMessage: 'Are you claiming for Snow Equipment Replacement Hire?',
  },
  areYouClaimingForSnowPrepaidExpenses: {
    id: 'fastCover.stepSnowSports.areYouClaimingForSnowPrepaidExpenses',
    defaultMessage: 'Are you claiming for Snow Prepaid Expenses?',
  },
  areYouClaimingForSnowResortClosure: {
    id: 'fastCover.stepSnowSports.areYouClaimingForSnowResortClosure',
    defaultMessage: 'Are you claiming for Snow Resort Closure?',
  },
  toAssistYourClaim: {
    id: 'fastCover.stepSnowSports.toAssistYourClaim',
    defaultMessage: 'To assist your claim:',
  },
  toAssistYourClaimDetail1: {
    id: 'fastCover.stepSnowSports.toAssistYourClaim',
    defaultMessage: 'We may need the below documents, please provide those that are applicable.',
  },
  toAssistYourClaimDetail2: {
    id: 'fastCover.stepSnowSports.toAssistYourClaim',
    defaultMessage: 'We may contact you to request further documentation',
  },
  document: {
    id: 'fastCover.stepSnowSports.document',
    defaultMessage: 'Documents',
  },
  document1: {
    id: 'fastCover.stepSnowSports.document1',
    defaultMessage: 'Police report or written report from a relevant authority or Travel Provider (Airline, hotel, Cruise Liner, Tour Company etc.).',
  },
  document2: {
    id: 'fastCover.stepSnowSports.document2',
    defaultMessage: 'Damage or Repair report.',
  },
  document3: {
    id: 'fastCover.stepSnowSports.document3',
    defaultMessage: 'Quote for repair or replacement.',
  },
  document4: {
    id: 'fastCover.stepSnowSports.document4',
    defaultMessage: 'Purchase receipt or other Evidence of Ownership for each item claimed.',
  },
  document5: {
    id: 'fastCover.stepSnowSports.document5',
    defaultMessage: 'For all losses or delays caused by your Transport Provider, a \'Property Irregularity Report\' from the Transport Provider.',
  },
  document6: {
    id: 'fastCover.stepSnowSports.document6',
    defaultMessage: 'Written evidence from the Transport Provider confirming the days and hours your Snow Sport Equipment was delayed and the time that it was returned to you.',
  },
  document7: {
    id: 'fastCover.stepSnowSports.document7',
    defaultMessage: 'Written confirm from medical practitioner of the nature of your injury or sickness.',
  },
  document8: {
    id: 'fastCover.stepSnowSports.document8',
    defaultMessage: 'A coppy of your pre-book and repaid lift passes, snow sports equipment hire or lessons expenses.',
  },
  document9: {
    id: 'fastCover.stepSnowSports.document9',
    defaultMessage: 'A copy of your itinerary.',
  },
  document10: {
    id: 'fastCover.stepSnowSports.document10',
    defaultMessage: 'A copy of your pre-booked and re-paid travel itinerary.',
  },
  document11: {
    id: 'fastCover.stepSnowSports.document11',
    defaultMessage: 'Written confirmation from the management of the resort stating the reason for the resort closure and how long the closure lasted.',
  },
  provideExplanation: {
    id: 'fastCover.stepSnowSports.provideExplanation',
    defaultMessage: 'If you cannot provide any of the above documents, please provide an explanation why you are unable to.',
  },
  ifYourSnowSportEquipmentsWasLostStolenOrDamagedPleaseTellUs: {
    id: 'fastCover.stepSnowSports.patientName',
    defaultMessage: 'If your Snow Sport Equipments was lost, stolen or damaged please tell us:',
  },
  howItHappened: {
    id: 'fastCover.stepSnowSports.howItHappened',
    defaultMessage: '1. How it happened',
  },
  whereYouWereInRelationToTheItem: {
    id: 'fastCover.stepSnowSports.whereYouWereInRelationToTheItem',
    defaultMessage: '2. Provide details of where you were in relation to the item at the time of loss, theft or damage',
  },
  anyThingAdditionalToAdd: {
    id: 'fastCover.stepSnowSports.anyThingAdditionalToAdd',
    defaultMessage: '3. Anything additional to add?',
  },
  areYouClaimingFor: {
    id: 'fastCover.stepSnowSports.areYouClaimingFor',
    defaultMessage: 'Are you claiming for',
  },
  loss: {
    id: 'fastCover.stepSnowSports.loss',
    defaultMessage: 'Loss',
  },
  theft: {
    id: 'fastCover.stepSnowSports.theft',
    defaultMessage: 'Theft',
  },
  damage: {
    id: 'fastCover.stepSnowSports.damage',
    defaultMessage: 'Damage',
  },
  delay: {
    id: 'fastCover.stepSnowSports.delay',
    defaultMessage: 'Delay',
  },
  whoDidYouReportThisTo: {
    id: 'fastCover.stepSnowSports.whoDidYouReportThisTo',
    defaultMessage: 'Who did you report this to?',
  },
  police: {
    id: 'fastCover.stepSnowSports.police',
    defaultMessage: 'Police',
  },
  hotelManagement: {
    id: 'fastCover.stepSnowSports.hotelManagement',
    defaultMessage: 'Hotel Management',
  },
  cruiseShip: {
    id: 'fastCover.stepSnowSports.cruiseShip',
    defaultMessage: 'Cruise Ship',
  },
  airline: {
    id: 'fastCover.stepSnowSports.airline',
    defaultMessage: 'Airline',
  },
  tourGuide: {
    id: 'fastCover.stepSnowSports.tourGuide',
    defaultMessage: 'Tour Guide',
  },
  other: {
    id: 'fastCover.stepSnowSports.other',
    defaultMessage: 'Other (please describe)',
  },
  notReported: {
    id: 'fastCover.stepSnowSports.notReported',
    defaultMessage: 'Not Reported',
  },
  otherDescription: {
    id: 'fastCover.stepSnowSports.otherDescription',
    defaultMessage: 'Other description',
  },
  reportReferenceNumber: {
    id: 'fastCover.stepSnowSports.reportReferenceNumber',
    defaultMessage: 'Report Reference Number',
  },
  descriptionOfItem: {
    id: 'fastCover.stepSnowSports.descriptionOfItem',
    defaultMessage: 'Description of item',
  },
  datePurchased: {
    id: 'fastCover.stepSnowSports.datePurchased',
    defaultMessage: 'Date purchased',
  },
  storeWhereItemWasPurchased: {
    id: 'fastCover.stepSnowSports.storeWhereItemWasPurchased',
    defaultMessage: 'Store where item was purchased',
  },
  purchasePrice: {
    id: 'fastCover.stepSnowSports.purchasePrice',
    defaultMessage: 'Purchase price',
  },
  currency: {
    id: 'fastCover.stepSnowSports.currency',
    defaultMessage: 'Currency',
  },
  amountClaimed: {
    id: 'fastCover.stepSnowSports.amountClaimed',
    defaultMessage: 'Amount claimed',
  },
  proofOfPurchaseAttached: {
    id: 'fastCover.stepSnowSports.proofOfPurchaseAttached',
    defaultMessage: 'Proof of purchase attached',
  },
  addAdditionalItem: {
    id: 'fastCover.stepSnowSports.addAdditionalItem',
    defaultMessage: 'Add Additional Item',
  },
  addItem: {
    id: 'fastCover.stepSnowSports.addItem',
    defaultMessage: 'Items Claimed',
  },
  item: {
    id: 'fastCover.stepSnowSports.item',
    defaultMessage: 'Item',
  },
  claimed: {
    id: 'fastCover.stepSnowSports.claimed',
    defaultMessage: 'Claimed',
  },
  patientName: {
    id: 'fastCover.stepSnowSports.patientName',
    defaultMessage: 'Patient\'s name',
  },
  relationshipToYou: {
    id: 'fastCover.stepSnowSports.relationshipToYou',
    defaultMessage: 'Relationship to you',
  },
  patientDateOfBirth: {
    id: 'fastCover.stepSnowSports.patientDateOfBirth',
    defaultMessage: 'Patients Date of Birth',
  },
  medicareNumber: {
    id: 'fastCover.stepSnowSports.medicareNumber',
    defaultMessage: 'Medicare number',
  },
  whatIsYourInjuryOrIllness: {
    id: 'fastCover.stepSnowSports.whatIsYourInjuryOrIllness',
    defaultMessage: 'What is your injury or illness?',
  },
  didThisOccurWhilstEngagingInSnowSportActivity: {
    id: 'fastCover.stepSnowSports.didThisOccurWhilstEngagingInSnowSportActivity',
    defaultMessage: 'Did this occur whilst engaging in Snow Sport activity?',
  },
  wasTheInjuredIllTravellerAnInpatient: {
    id: 'fastCover.stepSnowSports.wasTheInjuredIllTravellerAnInpatient',
    defaultMessage: 'Was the injured/ill traveller an inpatient?',
  },
  cancellationExpenses: {
    id: 'fastCover.stepSnowSports.cancellationExpenses',
    defaultMessage: 'Pre-Paid Expenses Claimed',
  },
  addCancellationExpense: {
    id: 'fastCover.stepSnowSports.addCancellationExpense',
    defaultMessage: 'Add Pre-Paid Expense',
  },
  cancellationExpenseTitle: {
    id: 'fastCover.stepSnowSports.cancellationExpenseTitle',
    defaultMessage: 'Expense {index}',
  },
  cancellationExpensesDateCancelled: {
    id: 'fastCover.stepSnowSports.cancellationExpenses.dateCancelled',
    defaultMessage: 'Date Pre-Paid',
  },
  cancellationExpensesCancelledBookingDescription: {
    id: 'fastCover.stepSnowSports.cancellationExpenses.cancelledBookingDescription',
    defaultMessage: 'Description',
  },
  cancellationExpensesSupplier: {
    id: 'fastCover.stepSnowSports.cancellationExpenses.supplier',
    defaultMessage: 'Supplier',
  },
  cancellationExpensesPrePaidAmount: {
    id: 'fastCover.stepSnowSports.cancellationExpenses.cancellationExpensesPrePaidAmount',
    defaultMessage: 'Pre-Paid Amount',
  },
  cancellationExpensesRefundCompensationReceived: {
    id: 'fastCover.stepSnowSports.cancellationExpenses.refundCompensationReceived',
    defaultMessage: 'Refund/Compensation Received',
  },
  cancellationExpensesCurrency: {
    id: 'fastCover.stepSnowSports.cancellationExpenses.cancellationExpensesCurrency',
    defaultMessage: 'Currency',
  },
  textBoxEg: {
    id: 'fastCover.stepSnowSports.cancellationExpenses.textBoxEg',
    defaultMessage: 'e.g: {value}',
  },
  additionalExpenses: {
    id: 'fastCover.stepSnowSports.additionalExpenses',
    defaultMessage: 'Additional Expenses',
  },
  additionalExpenseTitle: {
    id: 'fastCover.stepSnowSports.additionalExpenseTitle',
    defaultMessage: 'Additional Expense {index}',
  },
  addAdditionalExpense: {
    id: 'fastCover.stepSnowSports.additionalExpenses.addAdditionalExpense',
    defaultMessage: 'Add Additional expenses',
  },
  additionalExpensesDateOfExpense: {
    id: 'fastCover.stepSnowSports.additionalExpenses.dateOfExpense',
    defaultMessage: 'Date of Expense',
  },
  additionalExpensesDescription: {
    id: 'fastCover.stepSnowSports.additionalExpenses.description',
    defaultMessage: 'Description',
  },
  additionalExpensesSupplier: {
    id: 'fastCover.stepSnowSports.additionalExpenses.supplier',
    defaultMessage: 'Supplier',
  },
  additionalExpensesAmountPaid: {
    id: 'fastCover.stepSnowSports.additionalExpenses.amountPaid',
    defaultMessage: 'Amount Paid',
  },
  additionalExpensesCurrency: {
    id: 'fastCover.stepSnowSports.additionalExpenses.additionalExpensesCurrency',
    defaultMessage: 'Currency',
  },
  isRequired: {
    id: 'fastCover.stepSnowSports.isRequired',
    defaultMessage: '\'{defaultMessage}\' is required',
  },
  expenseTableRequired: {
    id: 'fastCover.stepSnowSports.expenseTableRequired',
    defaultMessage: 'Expense table fields are required fields.',
  },
  additionExpenseRequired: {
    id: 'fastCover.stepSnowSports.additionExpenseRequired',
    defaultMessage: 'Additional Expense table fields are required fields.',
  },
  cancellationExpenseRequired: {
    id: 'fastCover.stepSnowSports.cancellationExpenseRequired',
    defaultMessage: 'Cancellation expenses table fields are required fields.',
  },
  dateRefundWasReceived: {
    id: 'fastCover.stepSnowSports.dateRefundWasReceived',
    defaultMessage: 'Date Refund was Received',
  },
  areThereAnyAdditionalExpensesToBeClaimed: {
    id: 'fastCover.stepSnowSports.areThereAnyAdditionalExpensesToBeClaimed',
    defaultMessage: 'Are there any additional expenses to be claimed?',
  },
  itemWithIdx: {
    id: 'fastCover.stepSnowSports.itemWithIdx',
    defaultMessage: 'Item {idx}',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepSnowSports/messages.js